import { Skeleton } from "@/shared/ui";

export default function HistoryListSkeleton() {
  return (
    <div className="flex flex-col gap-5 mt-4 max-h-[400px] overflow-hidden">
      {Array.from({ length: 5 }, (_, i) => (
        <div key={i} className="flex gap-3">
          <Skeleton circle width={10} height={10} />
          <div className="flex-1 flex flex-col gap-1">
            <Skeleton height={12} width={120} />
            <Skeleton height={14} width={160} />
            <Skeleton height={12} width="50%" />
          </div>
        </div>
      ))}
    </div>
  );
}
